module.exports = __webpack_public_path__ + "static/img/mi9Pro.7acfd78a.png";